import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const TAB_DEFS = [
    { id: "connect", label: "Connect endpoints" },
    { id: "tokens", label: "Tokens" },
    { id: "installers", label: "Installers" },
];

export function useEndpointViewTabs({ active, canReadTokens = true, canInstallers = true }) {
    const [, setSearchParams] = useSearchParams();

    const openView = useCallback((view) => {
        setSearchParams((current) => {
            const next = new URLSearchParams(current);
            next.set("mode", "endpoints");
            next.set("adminView", view);
            next.delete("settingsView");
            return next;
        });
    }, [setSearchParams]);

    return useMemo(() => TAB_DEFS
        .filter((tab) => tab.id === "connect" || (tab.id === "tokens" ? canReadTokens : canInstallers))
        .map((tab) => ({
            ...tab,
            active: tab.id === active,
            dot: tab.id === active ? "bg-[color:var(--green)]" : undefined,
            onSelect: tab.id === active ? undefined : () => openView(tab.id),
            onClose: tab.id === active && tab.id !== "connect" ? () => openView("connect") : undefined,
        })), [active, canInstallers, canReadTokens, openView]);
}
